/** Query keys for per-user UI preferences (`api/me/preferences`). */
export const preferenceKeys = {
  all: ["me-preferences"] as const,
  key: (key: string) => [...preferenceKeys.all, key] as const,
};
